/**
 * На узком экране: три кнопки гаснут, View all появляется при скролле.
 * На десктопе то же делает applyPcPositions.
 */

import { useEffect } from "react";

const MOBILE_MQ = "(max-width: 1100px)";

function useLatestWorksBtnFade(rootRef) {
    useEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        const mq = window.matchMedia(MOBILE_MQ);

        const apply = () => {
            if (!mq.matches) return;
            const rect = root.getBoundingClientRect();
            const start = Math.min(window.innerHeight * 0.42, 320);
            const end = 48;
            const t = Math.min(1, Math.max(0, (start - rect.top) / Math.max(start - end, 1)));
            root.style.setProperty("--works-btn-fade", t.toFixed(4));
            root.classList.toggle("latest-works-block_all", t > 0.5);
        };

        apply();
        window.addEventListener("scroll", apply, { passive: true });
        window.addEventListener("resize", apply);
        mq.addEventListener("change", apply);
        return () => {
            window.removeEventListener("scroll", apply);
            window.removeEventListener("resize", apply);
            mq.removeEventListener("change", apply);
        };
    }, [rootRef]);
}

export default useLatestWorksBtnFade;
// hooks/useLatestWorksBtnFade.js
